import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { recapService } from '../services';
import { FaUser, FaStar, FaTrophy, FaChevronRight } from 'react-icons/fa';
import './RecapSelection.css';

const RecapSelection = () => {
  const navigate = useNavigate();
  const [characters, setCharacters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedYear] = useState(2025);

  useEffect(() => {
    loadCharacters();
  }, [selectedYear]);

  const loadCharacters = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await recapService.getUserCharacters(selectedYear);
      setCharacters(response.data);
    } catch (err) {
      console.error('Error loading characters:', err);
      setError('Erro ao carregar personagens. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const viewRecap = (characterId) => {
    navigate(`/app/recap/${characterId}`);
  };

  if (loading) {
    return (
      <div className="recap-selection-loading">
        <div className="loader"></div>
        <p>Carregando seus personagens...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="recap-selection-error">
        <h2>⚠️ {error}</h2>
        <button onClick={loadCharacters} className="btn-retry">
          Tentar Novamente
        </button>
      </div>
    );
  }

  return (
    <div className="recap-selection-container">
      <div className="recap-selection-header">
        <h1 className="recap-selection-title">
          Retrospectiva {selectedYear}
        </h1>
        <p className="recap-selection-subtitle">
          Reviva a jornada épica dos seus personagens no Clã Revolution
        </p>
      </div>

      {characters.length === 0 ? (
        <div className="no-characters">
          <FaUser className="no-characters-icon" />
          <h2>Nenhum personagem encontrado</h2>
          <p>Você ainda não possui personagens cadastrados para visualizar a retrospectiva de {selectedYear}.</p>
          <button onClick={() => navigate('/app/characters')} className="btn-create">
            Criar Personagem
          </button>
        </div>
      ) : (
        <div className="characters-grid">
          {characters.map((character) => (
            <div
              key={character.id}
              className="character-card"
              onClick={() => viewRecap(character.id)}
            >
              <div className="character-card-header">
                <div className="character-avatar">
                  <FaUser />
                </div>
                {!character.isActive && (
                  <div className="character-inactive-badge">Inativo</div>
                )}
              </div>

              <div className="character-card-body">
                <h3 className="character-name">{character.name}</h3>
                <p className="character-class">{character.class}</p>

                <div className="character-stats">
                  <div className="character-stat">
                    <FaTrophy className="stat-icon" />
                    <span>Level {character.level}</span>
                  </div>
                  <div className="character-stat">
                    <FaStar className="stat-icon" />
                    <span>{character.totalPoints.toLocaleString()} pts</span>
                  </div>
                </div>
              </div>

              <div className="character-card-footer">
                <button className="btn-view-recap">
                  Ver Retrospectiva <FaChevronRight />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="recap-selection-footer">
        <p className="footer-text">
          Cada retrospectiva é única e personalizada com base na jornada do seu personagem.
        </p>
        <p className="footer-battle-cry">AVANTE REVO</p>
      </div>
    </div>
  );
};

export default RecapSelection;
